import moment from "moment";
import { IDueDate } from "../config/due_date";

export const optimizeFuturePayments = (item: any) => {
    item.due_date = moment(item.due_date);
    return item;
};

export const sortDueDates = (dueDates: IDueDate[]): IDueDate[] => {
    return dueDates
        .map(dueDate => ({
            ...dueDate,
            payments: [...dueDate.payments].sort((a, b) => b.amount - a.amount)
        }))
        .sort((a, b) => a.due_date.valueOf() - b.due_date.valueOf());
};
